import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ButtonBaseComponent } from './button-base.component';


@Component({
	selector: 'app-button-close',
	templateUrl: './CoreButtonRaised.html'
})
export class ButtonCloseComponent extends ButtonBaseComponent {
	@HostBinding('class') class = 'adn-material-button';

	@Input()
	public iconClass = 'fa-window-close';
	@Input()
	public titleTranslateKey = 'button.close';
	@Input()
	public color = 'primary';
	@Input()
	public disabled: boolean = false;

	@Input()
	public type = 'button';


	@Input()
	public hintTranslateKey: string;


	@Output()
	action: EventEmitter<ButtonBaseComponent> = new EventEmitter<ButtonBaseComponent>();
}